import Session from "./Session";

export const areRolesAllowed = (...roles) => {
    return !!roles.includes(Session.getRole().name);
};